export const PAGE_SIZE_DESKTOP = 10;
export const PAGE_SIZE_MOBILE  = 5;

export const LEVEL_NAME = {
    4: 'Платиновый',
    3: 'Золотой',
    2: 'Серебряный',
    1: 'Бронзовый',
};